import {RequestController as $request} from "@/plugins/fetch";
import {parseResponseJSON} from "@/utils";

export default {
    state: {
        msg: null
    },
    actions: {
        reflectMessage ({commit}, data) {

            return $request
                .fetch(process.env.apiUrl + process.env.stage + "/demo", {
                    method: "POST",
                    body: JSON.stringify(data)
                })
                .then(parseResponseJSON)
                .then(result => commit("setMessage", result))
                .catch(console.error); // eslint-disable-line no-console
        }
    },
    mutations: {
        setMessage (state, data) {
            try {
                state.msg = data;
            } catch (err) {
                Promise.reject(err);
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/demo.js